import { render, staticRenderFns } from "./RelatorioPerformanceRegiaoFiltro.vue?vue&type=template&id=4f308b74"
import script from "./RelatorioPerformanceRegiaoFiltro.vue?vue&type=script&lang=js"
export * from "./RelatorioPerformanceRegiaoFiltro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports